/* HF contact measurement. Purchase remains owned by the native Google app pixel. */
(function () {
  'use strict';
  if (window.hfEnquiryTrackingLoaded) return;
  window.hfEnquiryTrackingLoaded = true;

  var STREAM = 'G-77DGHQ0J3E';
  var KEY = 'hf_enquiry_pending_v1';
  var TTL = 10 * 60 * 1000;
  var tag = null;
  var loader = null;
  var inFlight = false;
  var qaSent = false;
  var qaRequested = new URLSearchParams(window.location.search).get('hf_enquiry_qa') === '1';
  var interests = {
    'Private Floral Workshop': 'private_workshop',
    'Private Floral Workshop (Min. 5 pax)': 'private_workshop',
    'Corporate Floral Workshop': 'corporate_workshop',
    'DIY Floral Bar': 'diy_floral_bar',
    'DIY Floral Bar and/or Potpourri Bar': 'diy_floral_bar',
    'DIY Fresh Flower Bar': 'diy_fresh_flower_bar',
    'DIY Potpourri & Crystal Bar': 'diy_potpourri_crystal_bar',
    'DIY Plant Bar': 'diy_plant_bar',
    'A mix of experience bars': 'diy_experience_bars',
    'Corporate Gifting': 'corporate_gifting',
    'Microgreens and/or Edible flowers Workshop': 'edible_flower_workshop',
    'Others': 'other'
  };

  function qaStatus(status, mode) {
    if (!qaRequested) return;
    document.querySelectorAll('[data-hf-enquiry-form]').forEach(function (container) {
      container.setAttribute('data-hf-enquiry-qa-status', status);
      if (mode) container.setAttribute('data-hf-enquiry-qa-mode', mode);
    });
  }

  function privacyReady() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function';
  }

  function permitted() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function'
        && privacy.analyticsProcessingAllowed() === true;
    } catch (error) {
      console.warn('HF enquiry measurement: consent could not be checked.');
      return false;
    }
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(KEY); }
    catch (error) { console.warn('HF enquiry measurement: storage unavailable.'); }
  }

  function pending(path) {
    try {
      var raw = window.sessionStorage.getItem(KEY);
      if (!raw || raw.length > 1024) { clearPending(); return null; }
      var saved = JSON.parse(raw);
      if (!saved || saved.path !== path || !/^[a-f0-9]{32}$/.test(saved.id)
        || Object.values(interests).indexOf(saved.type) < 0
        || !Number.isFinite(saved.at) || Date.now() < saved.at || Date.now() - saved.at > TTL) {
        clearPending();
        return null;
      }
      return saved;
    } catch (error) {
      clearPending();
      return null;
    }
  }

  function retain(form, path) {
    clearPending();
    if (!permitted() || !form.checkValidity() || !window.crypto) return;
    var email = form.querySelector('[name="contact[email]"]');
    var message = form.querySelector('[name="contact[body]"], [name="contact[message]"]');
    var interest = form.querySelector('input[type="radio"][name="contact[i-am-interested-in]"]:checked')
      || form.querySelector('select[name="contact[i-am-interested-in]"]');
    var type = interest && Object.prototype.hasOwnProperty.call(interests, interest.value)
      ? interests[interest.value] : null;
    if (!email || !email.value.trim() || !email.checkValidity()
      || !message || !message.value.trim() || !type) return;
    try {
      var bytes = window.crypto.getRandomValues(new Uint8Array(16));
      var id = Array.from(bytes).map(function (value) { return value.toString(16).padStart(2, '0'); }).join('');
      window.sessionStorage.setItem(KEY, JSON.stringify({ id: id, path: path, type: type, at: Date.now() }));
    } catch (error) { console.warn('HF enquiry measurement: could not retain submission.'); }
  }

  function isolatedTag() {
    qaStatus('loading', 'isolated_gtag');
    window.hfEnquiryDataLayer = window.hfEnquiryDataLayer || [];
    tag = function () { window.hfEnquiryDataLayer.push(arguments); };
    tag('consent', 'default', {
      analytics_storage: 'denied', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied'
    });
    tag('js', new Date());
    return new Promise(function (resolve) {
      var script = document.createElement('script');
      var settled = false;
      var timer = setTimeout(function () {
        settled = true;
        script.remove();
        console.warn('HF enquiry measurement: Google transport timed out.');
        qaStatus('timeout');
        resolve(null);
      }, 8000);
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + STREAM + '&l=hfEnquiryDataLayer';
      script.onload = function () {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (!permitted()) { resolve(null); return; }
        tag('consent', 'update', { analytics_storage: 'granted' });
        tag('config', STREAM, {
          send_page_view: false, cookie_prefix: 'hf_enquiry', cookie_expires: 0,
          cookie_update: false, allow_google_signals: false,
          allow_ad_personalization_signals: false
        });
        resolve(tag);
      };
      script.onerror = function () {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        script.remove();
        console.warn('HF enquiry measurement: Google transport unavailable.');
        qaStatus('load_error');
        resolve(null);
      };
      document.head.appendChild(script);
    });
  }

  function transport() {
    if (typeof window.gtag === 'function') {
      qaStatus('ready', 'existing_gtag');
      return Promise.resolve(window.gtag);
    }
    // Google supports one layer per page. Do not compete with another parent tag.
    if (window.dataLayer) {
      qaStatus('blocked', 'existing_layer_without_gtag');
      return Promise.resolve(null);
    }
    if (!loader) loader = isolatedTag();
    return loader;
  }

  function send(name, data, finish) {
    if (!permitted()) { clearPending(); return; }
    if (name === 'generate_lead' && inFlight) return;
    if (name === 'generate_lead') inFlight = true;
    transport().then(function (receiver) {
      if (!receiver) {
        inFlight = false;
        console.warn('HF enquiry measurement: transport could not be used.');
        return;
      }
      if (!privacyReady()) return;
      if (!permitted()) { clearPending(); return; }
      // Consume before dispatch: reloads or a late callback must not duplicate a lead.
      finish();
      qaStatus('dispatch_requested');
      receiver('event', name, {
        send_to: STREAM, lead_type: data.type, form_id: 'hf_contact_enquiry',
        page_location: 'https://www.helloflowers.sg' + data.path,
        page_referrer: '', page_title: 'Hello Flowers enquiry',
        enquiry_id: data.id, transport_version: 'hf_enquiry_v1',
        event_callback: name === 'hf_enquiry_transport_qa'
          ? function () { qaStatus('tag_callback_received'); } : undefined
      });
    }).catch(function () {
      qaStatus('dispatch_error');
      console.warn('HF enquiry measurement: event dispatch failed.');
    });
  }

  function run() {
    var containers = document.querySelectorAll('[data-hf-enquiry-form]');
    containers.forEach(function (container) {
      var form = container.querySelector('form');
      var path = window.location.pathname;
      if (!form || !/^\/(pages|collections)\/[a-z0-9-]+$/.test(path)) return;
      if (!form.hfEnquiryBound) {
        form.hfEnquiryBound = true;
        form.addEventListener('submit', function () { retain(form, path); });
      }
      // The marker was consented before the POST. Leave it unread while the
      // privacy API loads; an explicit denial still removes it.
      if (!privacyReady()) { qaStatus('waiting_for_privacy_api'); return; }
      if (!permitted()) { clearPending(); qaStatus('consent_blocked'); return; }
      var saved = pending(path);
      if (saved && container.querySelector('[data-hf-enquiry-success]')) {
        send('generate_lead', saved, clearPending);
      }
      // Explicit operator transport check; never a lead, key event or customer email.
      if (!qaSent && qaRequested) {
        qaSent = true;
        send('hf_enquiry_transport_qa', { id: 'transport_qa', type: 'qa', path: path }, function () {});
      }
    });
  }

  document.addEventListener('visitorConsentCollected', function () {
    if (!permitted()) {
      clearPending();
      if (tag) {
        tag('consent', 'update', { analytics_storage: 'denied' });
        ['hf_enquiry_ga', 'hf_enquiry_ga_77DGHQ0J3E'].forEach(function (name) {
          ['', '; domain=helloflowers.sg', '; domain=www.helloflowers.sg'].forEach(function (domain) {
            document.cookie = name + '=; Max-Age=0; path=/' + domain;
          });
        });
      }
    }
  });
  run();
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    var privacySettled = false;
    var privacyTimer = setTimeout(function () {
      privacySettled = true;
      clearPending();
      qaStatus('privacy_api_timeout');
      console.warn('HF enquiry measurement: consent API timed out.');
    }, 5000);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (privacySettled) return;
      privacySettled = true;
      clearTimeout(privacyTimer);
      if (error) {
        clearPending();
        console.warn('HF enquiry measurement: consent API unavailable.');
        return;
      }
      run();
    });
  }
}());
